import {
    fetchNews,
    fetchNotifications
} from '../appSlice';

export default function ssrFetch({store, timeout}) {
    const options = timeout ? {timeout} : {};

    return Promise.all([
        store.dispatch(fetchNews({options})),
        store.dispatch(fetchNotifications({options}))
    ]);
}
